import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AppService } from './app.service';
// import * as decode from 'jwt-decode';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

@Injectable({
  providedIn: 'root'
})
export class AppInsightsService {
  private isCardPaymentLogRequired = environment?.IsCardPaymentLogRequired === true;
  private appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: environment.appInsights.instrumentationKey
    }
  });
  constructor(private appService: AppService) {
    this.appService.isStable$.subscribe(() => {
      this.appInsights.loadAppInsights();
      const user = 'User12thMarch';
      this.appInsights.setAuthenticatedUserContext(user);
    });
  }
  logPageView(name?: string, url?: string, properties?: any, measurements?: any, duration?: number) {
    this.appInsights.trackPageView({
      name,
      uri: url,
      properties,
      measurements
    });
  }

  logEvent(name: string, properties?: any, measurements?: any) {
    this.appInsights.trackEvent(
      { name },
      {
        ...properties,
        measurements
      }
    );
  }

  logException(exception: Error, handledAt?: string, properties?: any, measurements?: any) {
    this.appInsights.trackException({
      exception,
      properties: {
        ...properties,
        handledAt
      },
      measurements
    });
  }

  logTrace(message: string, properties?: any, severityLevel?: any) {
    this.appInsights.trackTrace(
      {
        message,
        severityLevel
      },
      properties
    );
  }

  logPaymentEvent(isCardPayment, name: string, properties?: any, measurements?: any) {
    if (this.isCardPaymentLogRequired && isCardPayment) {
      this.logEvent(name, properties, measurements);
    }
  }
}


